import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

const switcherKnobBackground = (isDisabled: boolean, isActive: boolean, inactiveColor: string) => {
  if (isDisabled) return colors.foregroundTertiary;
  if (isActive) return colors.primaryBackground;
  return inactiveColor;
};

export const styles = stylex.create({
  base: {
    appearance: 'none',
    cursor: { default: 'pointer', ':disabled': 'not-allowed' },
    display: 'flex',
    boxSizing: 'content-box',
    border: 'solid 1px',
    transition: 'all 0.5s ease',

    background: {
      ':disabled': colors.ghostBackground,
    },

    '::before': {
      content: '',
      borderRadius: '50%',
      transitionDuration: '0.3s',
      transitionProperty: 'background-color, transform',
      transform: 'translateX(0%)',
    },
  },

  //sizes
  small: (isActive) => ({
    inlineSize: anatomy['size-32'],
    borderRadius: anatomy['borderRadiusL'],
    blockSize: anatomy['size-16'],
    padding: '1px 2px',

    '::before': {
      inlineSize: anatomy['size-16'],
      blockSize: anatomy['size-16'],
      transform: `translateX(calc(${isActive && anatomy['size-32']} - 100%))`,
    },
  }),

  medium: (isActive) => ({
    inlineSize: anatomy['size-48'],
    borderRadius: anatomy['borderRadiusXl'],
    blockSize: anatomy['size-24'],
    padding: '2px 3px',

    '::before': {
      inlineSize: anatomy['size-24'],
      blockSize: anatomy['size-24'],
      transform: `translateX(calc(${isActive && anatomy['size-48']} - 100%))`,
    },
  }),

  large: (isActive) => ({
    inlineSize: anatomy['size-64'],
    borderRadius: anatomy['borderRadiusXxl'],
    blockSize: anatomy['size-36'],
    padding: '2px 3px',

    '::before': {
      inlineSize: anatomy['size-36'],
      blockSize: anatomy['size-36'],
      transform: `translateX(calc(${isActive && anatomy['size-64']} - 100%))`,
    },
  }),

  //variants
  default: (isActive, isDisabled) => ({
    borderColor: {
      default: colors.secondaryBackground,
      ':disabled': colors.foregroundTertiary,
    },

    ':checked': {
      background: {
        default: colors.accentBackground,
        ':disabled': colors.ghostBackground,
      },

      borderColor: {
        default: colors.accentBorder,
        ':disabled': colors.foregroundTertiary,
      },
    },

    '::before': {
      backgroundColor: switcherKnobBackground(isDisabled, isActive, colors.secondaryBackground),
    },
  }),

  primary: (isActive, isDisabled) => ({
    borderColor: {
      default: colors.accentBorder,
      ':disabled': colors.foregroundTertiary,
    },

    ':checked': {
      background: {
        default: `${isActive ? colors.accentBackground : colors.primaryBackground}`,
        ':disabled': colors.ghostBackground,
      },

      borderColor: {
        default: colors.accentBorder,
        ':disabled': colors.foregroundTertiary,
      },
    },

    '::before': {
      background: switcherKnobBackground(isDisabled, isActive, colors.accentBackground),
    },
  }),

  secondary: (isActive, isDisabled) => ({
    borderColor: {
      default: colors.secondaryBorder,
      ':disabled': colors.foregroundTertiary,
    },

    ':checked': {
      background: {
        default: `${isActive ? colors.secondaryBackground : false}`,
        ':disabled': colors.ghostBackground,
      },

      borderColor: {
        default: colors.secondaryBorder,
        ':disabled': colors.foregroundTertiary,
      },
    },

    '::before': {
      backgroundColor: switcherKnobBackground(isDisabled, isActive, colors.secondaryBackground),
    },
  }),
});
